import dayjs from '../dayjsConfig';

const getCurrentDayJsDate = (timeZone?: string, keepLocalTime?: boolean) => (
  timeZone ? dayjs().tz(timeZone, keepLocalTime) : dayjs()
);

export default getCurrentDayJsDate;
